import type { InitializableSdk } from './types';

interface SnippetConfig {
  event: string;
  title: string;
}

export const initializationSnippetConfig: Record<InitializableSdk, SnippetConfig> = {
  'android-client-sdk': { event: 'android-client-initialization', title: 'Kotlin' },
  'dotnet-server-sdk': { event: 'dotnet-server-initialization', title: 'C#' },
  'go-server-sdk': { event: 'go-server-initialization', title: 'Go' },
  'ios-client-sdk': { event: 'ios-client-initialization', title: 'Swift' },
  'java-server-sdk': { event: 'java-server-initialization', title: 'Java' },
  'js-client-sdk': { event: 'js-client-initialization', title: 'JavaScript' },
  'node-client-sdk': { event: 'node-client-initialization', title: 'JavaScript' },
  'node-server-sdk': { event: 'node-server-initialization', title: 'TypeScript' },
  'python-server-sdk': { event: 'python-server-initialization', title: 'Python' },
  'react-client-sdk': { event: 'react-client-initialization', title: 'TSX' },
  'react-native-client-sdk': { event: 'react-native-client-initialization', title: 'TSX' },
  'vue-client-sdk': { event: 'vue-client-initialization', title: 'JavaScript' },
};
